var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setup-password-page"},[_c('SetupPassword',{attrs:{"email":_vm.getEmail,"token":_vm.getToken}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }